export enum EIndustryExam {
  CEHA = 'CEHA',
  CEA = 'CEA',
  CES = 'CES',
  REA = 'REA',
  RES = 'RES',
  Others = 'Others',
}
